(function() {
function toolbox () {
 var that = this;
 
 // Gets byte from Int16
 this.getByte = function(value,leastSignificant) {
  if(!leastSignificant) value >>>= 8;
  return value&0xFF;
 };

 // Converts Int16 to little endian bytes
 this.setLittleEndianInt16 = function (bytes,index,value) {
  if(bytes.length >= index+2) for(var i=0; i<2; i++) bytes[index+i] = (value >>> i*8)&0xFF;
 };
 
 // Gets Int16 from little endian bytes
 this.getLittleEndianInt16 = function(bytes,index) {
  var result = -1;
  if(bytes.length >= index+2) {
   result = 0;
   for(var i= 0; i<2; i++) result |= (bytes[index+i] << 8*i);
  }
  return result;
 };
 
 // Converts Int32 to little endian bytes
 this.setLittleEndianInt32 = function (bytes,index,value) {
  if(bytes.length >= index+4) for(var i=0; i<4; i++) bytes[index+i] = (value >>> i*8)&0xFF;
 };
 
 // Gets Int32 from little endian bytes
 this.getLittleEndianInt32 = function(bytes,index) {
  var result = -1;
  if(bytes.length >= index+4) {
   result = 0;
   for(var i= 0; i<4; i++) result |= (bytes[index+i] << 8*i);
  }
  return result;
 };

 // Converts bytes to string
 this.bytes2String = function(a,i,l) {
  var bb = a.slice(i,i+l+1);
  try {
   return decodeURIComponent(bb.map(function(x){return '%'+x.toString(16).slice(-2)}).join(''));
  }catch(e) {
   return bb.map(function(x){return String.fromCharCode(+x)}).join('');
  }
 };
 
 // Converts bytes to hex number string
 this.bytes2HexString = function(a,i,l) {
  var bb = (i===undefined)?a:a.slice(i,i+l+1);
  return bb.map(function(x){return (('0'+x.toString(16)).slice(-2))}).join('');
 };
 
 // Converts bytes to numbers
 this.bytes2Number = function(array, lendian) {
   if(lendian) array.reverse();
   var hex = this.bytes2HexString(array, 0 , array.length);
   return parseInt(hex, 16);
 };
 
 // Converts number to 8 bytes
 this.number2Bytes = function(number) {
  // bit wise operation might be easy, but javascript allows bit wise only on 32 bit integers
  // so convert the number to hexa string first, and copy bytes to array
  var hn = number.toString(16);
  var bytes = new Array(8);
  var i=0;
  while(hn.length) {
   bytes[7-i] = parseInt(hn.substr(-2), 16);
   hn = hn.substr(0,hn.length-2);
   i++;
  }
  while(i<8) { bytes[7-i]=0; i++ }
  return bytes;
 };

 // Extracts subset of an array and joins elements ([a,t,e,s,t] -> [t,e,s,t] -> test)
 this.getCombinedValues = function(array,index,length) {
  var temp = array.slice(index,index+length);
  temp = temp.join('');
  return temp;
 };

 // Escapes &,<,>," characters
 this.htmlEscape = function(x) {
  return (''+x).replace('&','&amp;').replace('<','&lt;').replace('>','&gt;').replace('"','&quot;');
 };
 
 // Gets date from wtgserver time
 this.getDateFromServerTime = function(sec, ref) {
  var d = ref?ref:new Date(Date.UTC(2015, 0, 1, 0, 0, 0));
  return new Date(d.getTime()+(sec*1000));
 };
 
 // Gets current time as string (HH:MM)
 this.getCurrentTime = function() {
  var date = new Date();
  return that.get12HourTime(date);
 };
 
 this.get12HourTime = function(date, full) {
  var hours = date.getHours();
  var d = ("0" + date.getDate()).slice(-2) + "." + ("0" + (date.getMonth()+1)).slice(-2) + "." + date.getFullYear() + " ";
  return (full?d:"") + (((hours>12)?(hours-12):hours) + ":" + ("0" + date.getMinutes()).slice(-2)) + " " + (date.getHours()>11?"PM":"AM");
 };

 // Gets a subset of bytes
 this.getBytes = function(bytes, startIndex, length) {
  if((length<1) || (length > (bytes.length-startIndex))) return null;
  var temp = new Array(length);
  for(var i=0; i<length; i++){
  temp[i] = bytes[i+startIndex];
  }
  return temp;
 };
 
 // Validates a string for email
 this.validateEmail = function(email) {
  var filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return filter.test(email);
 };

 this.compareArrays = function(array1, array2) {
  var is_same = (array1.length == array2.length) && array1.every(	function(element, index) {
   return element === array2[index]; 
  });
  var is_less = (array1.length <= array2.length) && array1.every(	function(element, index) {
   return element <= array2[index]; 
  });
  return is_same?0:(is_less?-1:1);
 };
 
 this.getDateheader = function(msec) {
  var date = that.getDateFromServerTime(msec);
  var sdate = date.toUTCString();
  var day = date.getDate();
  var mnth = date.getMonth();
  var cdate = new Date(); //current date
  var cday = cdate.getDate();
  var cmnth = cdate.getMonth();// 0- 11
  if(mnth == (cmnth)) {
   if(day == cday) return "Today";
   else if(day == (cday-1)) return "Yesterday";
  }
  return sdate.slice(0,17); // like Wed, july 15 2015
 };
 
this.encodeText = function(string) {
 return (encodeURIComponent)?encodeURIComponent(string):escape(string);
};

this.decodeText = function(string) {
 return (decodeURIComponent)?decodeURIComponent(string):unescape(string);
};

 /**
  * Encodes multi-byte Unicode string into utf-8 multiple single-byte characters
  * (BMP / basic multilingual plane only).
  *
  * Chars in range U+0080 - U+07FF are encoded in 2 chars, U+0800 - U+FFFF in 3 chars.
  *
  * Can be achieved in JavaScript by unescape(encodeURIComponent(str)),
  * but this approach may be useful in other languages.
  *
  * @param {string} strUni Unicode string to be encoded as UTF-8.
  * @returns {string} Encoded string.
  */
 this.utf8Encode = function(strUni) {
  var strUtf = strUni.replace(
   /[\u0080-\u07ff]/g,  // U+0080 - U+07FF => 2 bytes 110yyyyy, 10zzzzzz
   function(c) {
    var cc = c.charCodeAt(0);
    return String.fromCharCode(0xc0 | cc>>6, 0x80 | cc&0x3f); }
  );
  strUtf = strUtf.replace(
   /[\u0800-\uffff]/g,  // U+0800 - U+FFFF => 3 bytes 1110xxxx, 10yyyyyy, 10zzzzzz
   function(c) {
    var cc = c.charCodeAt(0);
    return String.fromCharCode(0xe0 | cc>>12, 0x80 | cc>>6&0x3F, 0x80 | cc&0x3f); }
  );
  return strUtf;
 };

 /**
  * Decodes utf-8 encoded string back into multi-byte Unicode characters.
  *
  * Can be achieved JavaScript by decodeURIComponent(escape(str)),
  * but this approach may be useful in other languages.
  *
  * @param {string} strUtf UTF-8 string to be decoded back to Unicode.
  * @returns {string} Decoded string.
  */
 this.utf8Decode = function(strUtf) {
  // note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!
  var strUni = strUtf.replace(
   /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,  // 3-byte chars
   function(c) {  // (note parentheses for precedence)
    var cc = ((c.charCodeAt(0)&0x0f)<<12) | ((c.charCodeAt(1)&0x3f)<<6) | ( c.charCodeAt(2)&0x3f);
    return String.fromCharCode(cc); }
  );
  strUni = strUni.replace(
   /[\u00c0-\u00df][\u0080-\u00bf]/g,                 // 2-byte chars
   function(c) {  // (note parentheses for precedence)
    var cc = (c.charCodeAt(0)&0x1f)<<6 | c.charCodeAt(1)&0x3f;
    return String.fromCharCode(cc); }
  );
  return strUni;
 };

 this.stringtohex = function(str){
  var result = "";
  for (var i=0; i<str.length; i++) {
   var hex = str.charCodeAt(i).toString(16);
   result += ("0"+hex).slice(-2).toUpperCase();
  }
  return result;
 };
 this.hextostring = function(str){
  var hex = str.match(/.{1,2}/g) || [];
  var back = "";
  for(var j = 0; j<hex.length; j++)
   back += String.fromCharCode(parseInt(hex[j], 16));
  return back;
 };
}

if(typeof module !== 'undefined' && typeof module.exports !== 'undefined') module.exports = toolbox;
else window.toolbox = toolbox;
})();
